import {
    QueryFunction,
    QueryKey,
    useQuery,
    UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {
    EventsResponse,
} from 'features/events/api/events-api.service';
import { DashboardApiService } from '../api/dashboard-api.services';
import { dashboardQueryKeys } from './query-keys';



const { getDashboardcrosssalessummary } = DashboardApiService();

const getDashboardQuery = (
    params: any,
    options?: UseQueryOptions<any>,
): {
    queryKey: QueryKey;
    queryFn: QueryFunction<EventsResponse>;
    options?: UseQueryOptions<EventsResponse>;
} => ({
    queryKey: dashboardQueryKeys.list(params),
    queryFn: ({ signal }) => getDashboardcrosssalessummary(params, { config: { signal } }),
    ...options,
});

export const useGetDashboardCrossSummary = (
    params: any,
    options?: UseQueryOptions<any>,
) => {
    const { message } = App.useApp();

    return useQuery<any, Error>(
        getDashboardQuery(params, {
            onError: (error: unknown) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            ...options,
        }),
    );
};

